import { chooseConfig, Env } from './app';

let _vendorsUrl: string | undefined = undefined;

const vendorsUrls: Record<Env, string> = {
  local: 'https://local.app:3001',
  dev: 'https://dev-cos-mycs-vendor.testcosidexx.com',
  qa: 'https://qa-cos-mycs-vendor.testcosidexx.com',
  stage: 'https://stage-cos-mycs-vendor.cosidexx.com',
  prod: 'https://vendor.mycornerstone.idexx.com',
};

export const vendorsUrl = (): string => {
  if (!_vendorsUrl) {
    _vendorsUrl = chooseConfig(vendorsUrls);
  }
  return _vendorsUrl;
};
